<template>
  <organization-list-component />
</template>

<script>
import OrganizationListComponent from '@/components/organizations/List.vue'

export default {
  name: 'OrganizationListPage',
  components: {
    OrganizationListComponent
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/organizations/List.vue